import AdvertisingMasterImportPage from './AdvertisingMasterImportPage';

export default AdvertisingMasterImportPage
